import ProductPlaceholders from './ProductPlaceholders';

export default ProductPlaceholders;
